import { toast, ToastContainer, ToastOptions } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";
import styles from "./Toast.module.scss";

const defaultToastParams: ToastOptions = {
    position: toast.POSITION.BOTTOM_CENTER,
    autoClose: 5000,
    hideProgressBar: true
};

/**
 * Enum for message toast status
 */
enum MessageToast {
    Success,
    Error,
    Warning
}

/**
 * Component to render Toastify messages
 */
function Toast(): JSX.Element {
    return (
        <ToastContainer className={styles.toastContainer} />
    );
}

interface CustomToastOptions extends ToastOptions {}

/**
 * Displays a custom message in Toastify component.
 * @param type The type of the message.
 * @param message The custom message to display.
 * @param customOptions The custom toast options to apply.
 */
function displayToast(type: MessageToast, message: string, customOptions: Partial<CustomToastOptions> = {}): void {
    const options = { ...defaultToastParams, ...customOptions };

    switch (type) {
        case MessageToast.Success:
            toast.success(message, options);
            break;

        case MessageToast.Error:
            toast.error(message, options);
            break;

        case MessageToast.Warning:
            toast.warning(message, options);
            break;

        default:
            console.error(`Can't display toast for unknown type ${type}, defaulting to error.`);
            toast.error(message, options);
            break;
    }
}

export { CustomToastOptions, displayToast, MessageToast, Toast };
